import { render, staticRenderFns } from "./PlanProjectInfo.vue?vue&type=template&id=087983c3&scoped=true"
import script from "./PlanProjectInfo.vue?vue&type=script&lang=js"
export * from "./PlanProjectInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087983c3",
  null
  
)

export default component.exports